import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    Card,
    Frame,
    Toast,
    Button,
    Modal,
    TextField,
    Link,
    List,
    Layout
} from "@shopify/polaris";
import Styles from "./styles.module.scss";
import onboardingApi from "../../services/onboardingApi";

const StoreIntegration = ({
    ...props
}) => {
    const { error, onboarding, isLoading } = props;
    const [isShowErrorToast, setIsShowErrorToast] = useState(false);
    const [isShowCopyToast, setIsShowCopyToast] = useState(false);
    const [apiCalled, setApiCalled] = useState(false);
    const [failedValidationModalOpen, setFailedValidationModalOpen] =
        useState(false);
    const [successValidationModalOpen, setSuccessValidationModalOpen] =
        useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (error && error.error) {
            if (error.error !== "Invalid Session") {
                if (typeof error?.error === "string") {
                    setErrorMessage(error.error);
                }
                setIsShowErrorToast(true);
                setApiCalled(false);
            }
        }
    }, [error]);

    const checkValidation = async () => {
        setApiCalled(true);
        try {
            const data = await onboardingApi.validateACSIntegration();
            if (data.data.isStoreIntegrationValid) {
                setSuccessValidationModalOpen(true);
            } else {
                setFailedValidationModalOpen(true);
            }
            setApiCalled(false);
        } catch (err) {
            if (typeof err?.error?.error?.data === "string") {
                setErrorMessage(err.error.error.data);
            }
            setIsShowErrorToast(true);
            setApiCalled(false);
        }
    };

    const copyText = (selectedId) => {
        const copyText = document.getElementById(selectedId);
        copyText.select();
        document.execCommand("copy");
        setIsShowCopyToast(true);
    };

    return (
        <>
            <Layout>
                <Layout.AnnotatedSection
                    title="Update your currency settings"
                    description="Please follow the below instructions."
                >
                    <Card sectioned>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>

                            <div style={{ flex: 1 }} className={Styles["custom-last-child-margin"]}>
                                <List type="number">
                                    <List.Item>
                                        Click on this{" "}
                                        <Link
                                            url={`https://${props.auth.storeDetails.myshopify_domain}/admin/settings/general`}
                                            external
                                        >
                                            store details
                                        </Link>
                                    </List.Item>

                                    <List.Item>
                                        Go to the Store Defaults --&gt; Currency Display
                                    </List.Item>

                                    <List.Item>
                                        Click on three dots(...) and click on Change Currency Formatting
                                    </List.Item>
                                </List>
                            </div>

                            <div >
                                <Button
                                    loading={apiCalled}
                                    disabled={apiCalled}
                                    primary
                                    onClick={checkValidation}
                                >
                                    Verify
                                </Button>
                            </div>

                        </div>

                        <div className={Styles["custom-step-list"]}>
                            <List type="number">
                                <List.Item ></List.Item>
                                <List.Item ></List.Item>
                                <List.Item ></List.Item>
                                <List.Item >
                                    Update HTML with currency field with the below value
                                    <div className="mt-10 copyMainField">
                                        <TextField
                                            id="moneyFormatWithCurrencyCopy"
                                            label="HTML with currency"
                                            readOnly
                                            autoComplete="off"
                                            value={`${onboarding.moneyFormatWithCurrency}`}
                                            connectedRight={
                                                <Button plain onClick={() => copyText("moneyFormatWithCurrencyCopy")}>
                                                    Copy
                                                </Button>
                                            }
                                        />
                                    </div>
                                </List.Item>

                                <List.Item>
                                    Update HTML without currency field with the below value
                                    <div className="mt-10 copyMainField">
                                        <TextField
                                            id="moneyFormatCopy"
                                            label="HTML without currency"
                                            readOnly
                                            autoComplete="off"
                                            value={`${onboarding.moneyFormat}`}
                                            connectedRight={
                                                <Button plain onClick={() => copyText("moneyFormatCopy")}>
                                                    Copy
                                                </Button>
                                            }
                                        />
                                    </div>
                                </List.Item>

                                <List.Item>
                                    Click on Save button in the Shopify page
                                </List.Item>
                            </List>
                        </div>

                        <div className={Styles["dotted-partition"]}></div>

                        <div className={Styles["contact-us"]}>
                            If you are facing any problem then contact us in the chat box or send an email to{" "}
                            <a
                                rel="noreferrer noopener"
                                href="mailto:support@mlveda.com"
                                target="_blank"
                            >
                                <span className="emailLink notranslate">
                                    support@mlveda.com
                                </span>
                            </a>
                        </div>

                    </Card>

                    {/* <div style={{ marginTop: "20px" }}>
                        <Button
                            fullWidth
                            loading={apiCalled}
                            disabled={apiCalled}
                            primary
                            onClick={checkValidation}
                        >
                            Next
                        </Button>
                    </div> */}
                </Layout.AnnotatedSection>
            </Layout>
            {isShowCopyToast && (
                <Frame>
                    <Toast
                        duration={1500}
                        content={"Copied"}
                        onDismiss={() => {
                            setIsShowCopyToast(false);
                        }}
                    />
                </Frame>
            )}
            <Modal
                open={failedValidationModalOpen}
                onClose={() => setFailedValidationModalOpen(false)}
                title={`Failed`}
                primaryAction={{
                    content: "OK",
                    onAction: () => setFailedValidationModalOpen(false),
                }}
            >
                <Modal.Section>
                    <div className={`${Styles["success-main"]} ${Styles["noticeDiv-store"]}`}>
                        <div className={Styles["importantIcon-store"]}>!</div>
                        <div className={Styles["success-msg"]}>
                            Store currency setup failed. Please try again.
                        </div>
                    </div>

                    <div>
                        Currency settings are not properly updated. Please follow the
                        steps again. In case you are facing any issues please send an
                        email to{" "}
                        <a rel="noreferrer noopener" aria-label=" (opens in a new tab)" href="mailto:support@mlveda.com" target="_blank"><span className="emailLink notranslate">support@mlveda.com</span>{" "}</a>
                        and we will revert you back within 24 hours.
                    </div>
                </Modal.Section>
            </Modal>

            <Modal
                open={successValidationModalOpen}
                onClose={() => setSuccessValidationModalOpen(false)}
                title={`Success`}
                primaryAction={{
                    content: "OK",
                    onAction: () => setSuccessValidationModalOpen(false),
                }}
            >
                <Modal.Section>
                    <div className={Styles["success-main"]}>
                        <svg
                            version="1.1"
                            className={Styles["success-svg"]}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 130.2 130.2"
                        >
                            <circle
                                className={`${Styles["path"]} ${Styles["circle"]}`}
                                fill="none"
                                stroke="#04cea4"
                                strokeWidth="6"
                                strokeMiterlimit="10"
                                cx="65.1"
                                cy="65.1"
                                r="62.1"
                            />
                            <polyline
                                className={`${Styles["path"]} ${Styles["check"]}`}
                                fill="none"
                                stroke="#04cea4"
                                strokeWidth="6"
                                strokeLinecap="round"
                                strokeMiterlimit="10"
                                points="100.2,40.2 51.5,88.8 29.8,67.5 "
                            />
                        </svg>
                        <div className={Styles["success-msg"]}>
                            Store currency setup completed successfully!
                        </div>
                    </div>
                    <div className={Styles["empower-msg"]}>
                        <span className="font-weight-600">Awesome!</span> MLV Multi County Pricing app has been setup successfully on the store now. Let's just enable the app on the store in the next step and then you will be able to set prices for your products.
                    </div>
                </Modal.Section>
            </Modal>
            {isShowErrorToast && <Toast content={errorMessage || "Something went wrong!"} onDismiss={setIsShowErrorToast(false)} />}
        </>

    );
};

StoreIntegration.propTypes = {};

const mapStateToProps = (state) => {
    return {
        error: state.onboarding.error,
        auth: state.auth,
        onboarding: state.onboarding.onboarding,
        embededBlockStatus: state.embededBlockStatus.status
        // isLoading: state.onboarding.isLoading
    };
};

export default connect(
    mapStateToProps,
)(StoreIntegration);
